"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _colors = require("@material-ui/core/colors");

var _styles = require("@material-ui/core/styles");

var _unsupportedProp = _interopRequireDefault(require("@material-ui/core/utils/unsupportedProp"));

var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _colors2 = require("../../theme/colors");

var styles = {
  alternativeSelected: {},
  clickable: {},
  customIcon: {
    flexDirection: 'row-reverse'
  },
  deleteIcon: {},
  disabled: {
    '&$outlined, &$outlined:active, &$outlined:focus, &$outlined:hover': {
      '& > $iconDisabled': {
        color: _colors2.opacity.black[38],
        cursor: 'default'
      },
      backgroundColor: _colors.common.white,
      border: "1px solid ".concat(_colors2.opacity.black[24]),
      boxShadow: 'none',
      color: _colors2.opacity.black[38],
      cursor: 'default'
    },
    '&:not($outlined)': {
      '& > $iconDisabled': {
        color: _colors2.opacity.black[38],
        cursor: 'default'
      },
      backgroundColor: _colors2.opacity.black[4],
      boxShadow: 'none',
      color: _colors2.opacity.black[38],
      cursor: 'default'
    }
  },
  icon: {},
  iconDisabled: {},
  iconSmall: {
    fontSize: '16px',
    margin: '0 4px'
  },
  label: {},
  labelAlternativeSelected: {},
  labelDisabled: {
    color: _colors2.opacity.black[38]
  },
  labelOutlined: {},
  labelSelected: {
    '&$labelOutlined, &$labelAlternativeSelected': {
      color: _colors2.opacity.black[87]
    },
    color: _colors.common.white
  },
  labelSmall: {
    fontWeight: 400
  },
  outlined: {
    '&:active, &:focus, &$clickable:focus': {
      backgroundColor: _colors2.opacity.black[14]
    },
    border: "1px solid ".concat(_colors2.opacity.black[60])
  },
  selected: {
    '&:not($disabled)': {
      '& > $deleteIcon, & > $icon, & > $label': {
        color: _colors.common.white
      },
      '&$alternativeSelected': {
        '& > $deleteIcon, & > $icon': {
          color: _colors2.opacity.black[54]
        },
        backgroundColor: _colors2.opacity.primary[800][14],
        color: _colors2.opacity.black[87]
      },
      '&$outlined': {
        '& > $icon, & > $deleteIcon': {
          color: _colors2.opacity.black[54]
        },
        '& > $label': {
          color: _colors2.opacity.black[87]
        },
        backgroundColor: _colors2.opacity.primary[800][14],
        borderColor: _colors2.primary[800]
      },
      '&:active': {
        boxShadow: 'none'
      },
      backgroundColor: _colors2.primary[800],
      cursor: 'default'
    }
  },
  sizeMedium: {
    borderRadius: '16px',
    height: '32px',
    padding: '0 12px'
  },
  sizeSmall: {
    borderRadius: '12px',
    height: '24px',
    padding: '0 8px'
  },
  withIcon: {
    paddingRight: 0
  }
};
/**
 * Chips are used for filtering, as tags and labels, or as action items.
 * Chip are usually interactive.
 */

var _ref = _react["default"].createElement(_Close["default"], null);

var Chip = function Chip(props) {
  var _cx2, _cx4, _cx5, _cx6;

  var alternativeSelectedStyle = props.alternativeSelectedStyle,
      classes = props.classes,
      disabled = props.disabled,
      label = props.label,
      onDelete = props.onDelete,
      onDropDown = props.onDropDown,
      selected = props.selected,
      size = props.size,
      variant = props.variant,
      rest = (0, _objectWithoutProperties2["default"])(props, ["alternativeSelectedStyle", "classes", "disabled", "label", "onDelete", "onDropDown", "selected", "size", "variant"]);
  var isSmall = size === 'small';
  var icon = !rest.icon && onDropDown ? _react["default"].createElement(_ArrowDropDown["default"], {
    className: (0, _classnames["default"])(classes.icon, (0, _defineProperty2["default"])({}, classes.iconDisabled, disabled)),
    onClick: disabled ? undefined : onDropDown
  }) : undefined;
  return _react["default"].createElement(_Chip["default"], (0, _extends2["default"])({
    classes: {
      deleteIcon: (0, _classnames["default"])(classes.deleteIcon, (_cx2 = {}, (0, _defineProperty2["default"])(_cx2, classes.iconDisabled, disabled), (0, _defineProperty2["default"])(_cx2, classes.iconSmall, isSmall), _cx2)),
      icon: (0, _classnames["default"])(classes.icon, (0, _defineProperty2["default"])({}, classes.iconSmall, isSmall)),
      label: (0, _classnames["default"])(classes.label, (_cx4 = {}, (0, _defineProperty2["default"])(_cx4, classes.labelSelected, !disabled && selected), (0, _defineProperty2["default"])(_cx4, classes.labelSmall, isSmall), _cx4)),
      root: (0, _classnames["default"])((_cx5 = {}, (0, _defineProperty2["default"])(_cx5, classes.alternativeSelected, !disabled && selected && alternativeSelectedStyle), (0, _defineProperty2["default"])(_cx5, classes.clickable, rest.clickable), (0, _defineProperty2["default"])(_cx5, classes.customIcon, !!rest.icon || !!onDropDown), (0, _defineProperty2["default"])(_cx5, classes.outlined, variant === 'outlined'), (0, _defineProperty2["default"])(_cx5, classes.disabled, disabled), (0, _defineProperty2["default"])(_cx5, classes.selected, !disabled && selected), (0, _defineProperty2["default"])(_cx5, classes.sizeMedium, size === 'medium'), (0, _defineProperty2["default"])(_cx5, classes.sizeSmall, isSmall), (0, _defineProperty2["default"])(_cx5, classes.withIcon, !!rest.icon || !!onDropDown || !!onDelete), _cx5))
    },
    deleteIcon: isSmall ? _ref : undefined,
    icon: icon,
    label: _react["default"].createElement(_Typography["default"], {
      className: (0, _classnames["default"])((_cx6 = {}, (0, _defineProperty2["default"])(_cx6, classes.labelAlternativeSelected, !disabled && selected && alternativeSelectedStyle), (0, _defineProperty2["default"])(_cx6, classes.labelDisabled, disabled), (0, _defineProperty2["default"])(_cx6, classes.labelOutlined, variant === 'outlined'), (0, _defineProperty2["default"])(_cx6, classes.labelSelected, !disabled && selected), (0, _defineProperty2["default"])(_cx6, classes.labelSmall, isSmall), _cx6)),
      variant: isSmall ? 'overline' : 'body1'
    }, label),
    onDelete: onDelete && (disabled ? function () {} : onDelete),
    variant: variant
  }, rest));
};

Chip.defaultProps = {
  size: 'medium',
  variant: 'default'
};
Chip.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Use the alternative styling when the selected prop is true.
   */
  alternativeSelectedStyle: _propTypes["default"].bool,

  /**
   * Avatar element.
   */
  avatar: _propTypes["default"].element,

  /**
   * This property isn't supported.
   * Use the `component` property if you need to change the children structure.
   */
  children: _unsupportedProp["default"],

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes["default"].object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes["default"].string,

  /**
   * If true, the chip will appear clickable, and will raise when pressed,
   * even if the onClick property is not defined.
   * If false, the chip will not be clickable, even if onClick peoperty is defined.
   * This can be used, for example,
   * along with the component property to indicate an anchor Chip is clickable.
   */
  clickable: _propTypes["default"].bool,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes["default"].oneOf(['default', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].object]),

  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: _propTypes["default"].element,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Icon element.
   */
  icon: _propTypes["default"].element,

  /**
   * The content of the label.
   */
  label: _propTypes["default"].node,

  /**
   * @ignore
   */
  onClick: _propTypes["default"].func,

  /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: _propTypes["default"].func,

  /**
   * Callback function fired when the drop down icon is clicked.
   * If set, the drop down icon will be shown.
   */
  onDropDown: _propTypes["default"].func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes["default"].func,

  /**
   * @ignore
   */
  onKeyUp: _propTypes["default"].func,

  /**
   * If true, chip will be rendered with the 'selected' styling
   */
  selected: _propTypes["default"].bool,

  /**
   * The size of the Chip
   */
  size: _propTypes["default"].oneOf(['medium', 'small']),

  /**
   * @ignore
   */
  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /**
   * The variant to use.
   */
  variant: _propTypes["default"].oneOf(['default', 'outlined'])
} : {};

var _default = (0, _styles.withStyles)(styles)(Chip);

exports["default"] = _default;